import { environment } from '../environments/environment';

export const isDebugEnvironment = (): boolean => environment.name === 'debug';
